﻿import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionStorageService } from '../../../shared/session/session-storage/session-storage.service';


import { MortgageBorrowerData } from '../../interfaces/mortgage-borrower-data.interface';
import { SessionableMortgageDataModel } from '../../sessionable-mortgage-data-model';
import { MortgagePrimaryBorrowerDataModel } from './mortgage-primary-borrower-data/mortgage-primary-borrower-data.model';
import { MortgageCoBorrowerDataModel } from './mortgage-coborrower-data/mortgage-coborrower-data.model';

@Injectable()
export class MortgageBorrowerDataModel extends SessionableMortgageDataModel implements MortgageBorrowerData {

  // Data that is saved to session storage
  private _isInSpousalCoBorrowerFlow: boolean;

  // Indicates that the current user is a non-spouse co-borrower for the loan in context.
  private _isInNonSpousalCoBorrowerFlow: boolean;

  public isInSpousalCoBorrowerFlowChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // Data that is not saved to session storage
  public onLeadInfoPopulation: Observable<any>;
  public webBorrowerGuid: string;
  public primaryBorrowerSelected: boolean;

  constructor(protected sessionStorageService: SessionStorageService,
              private _primaryBorrowerData: MortgagePrimaryBorrowerDataModel,
              private _coBorrowerData: MortgageCoBorrowerDataModel) {
    super(sessionStorageService);
  }

  public populate(model?: MortgageBorrowerDataModel): MortgageBorrowerDataModel {

    const map = (mapping: (model: MortgageBorrowerDataModel) => boolean) => {
      return model ? mapping(model) : false;
    };

    this._primaryBorrowerData.populate(model ? model._primaryBorrowerData : null);
    this._coBorrowerData.populate(model ? model._coBorrowerData : null);

    this._isInSpousalCoBorrowerFlow = map(x => x._isInSpousalCoBorrowerFlow);
    this.isInSpousalCoBorrowerFlowChange.next(this.isInSpousalCoBorrowerFlow);
    this._isInNonSpousalCoBorrowerFlow = map(x => x._isInNonSpousalCoBorrowerFlow);

    return this;
  }

  protected map(model: any): MortgageBorrowerDataModel {
    return model._borrowerData;
  }

  protected save(setter: (model: MortgageBorrowerDataModel) => void): void {
    super.save(setter);
  }

  public clear() {
    this.isInSpousalCoBorrowerFlowChange.next(false);
  }

  public set primaryBorrowerData(value: MortgagePrimaryBorrowerDataModel) {
    this._primaryBorrowerData = value;
    this.save(x => x._primaryBorrowerData = value);
  }

  public get primaryBorrowerData(): MortgagePrimaryBorrowerDataModel {
    return this._primaryBorrowerData;
  }

  public set coBorrowerData(value: MortgageCoBorrowerDataModel) {
    this._coBorrowerData = value;
    this.save(x => x._coBorrowerData = value);
  }

  public get coBorrowerData(): MortgageCoBorrowerDataModel {
    return this._coBorrowerData;
  }

  public set isInSpousalCoBorrowerFlow(value: boolean) {
    this._isInSpousalCoBorrowerFlow = value;
    this.isInSpousalCoBorrowerFlowChange.next(value);
    this.save(x => x._isInSpousalCoBorrowerFlow = value);
  }

  public get isInSpousalCoBorrowerFlow(): boolean {
    return this._isInSpousalCoBorrowerFlow;
  }

  public set isInNonSpousalCoBorrowerFlow(value: boolean) {
    this._isInNonSpousalCoBorrowerFlow = value;
    this.save(x => x._isInNonSpousalCoBorrowerFlow = value);
  }

  public get isInNonSpousalCoBorrowerFlow(): boolean {
    return this._isInNonSpousalCoBorrowerFlow;
  }
}
